module.exports = __webpack_public_path__ + "static/media/contact-mb.9177d8c2.png";